module.exports = __webpack_public_path__ + "img/certTempTr.16d60b74.png";